import { IMAGE_NODE_TYPE } from '@main/shared/utils/lexical/editor-image';
import { type ImageDimensionConstraints } from '@main/shared/utils/lexical/image-dimensions';
import { type LexicalNode } from 'lexical';

export { IMAGE_NODE_TYPE, isEditorImageNodeType } from '@main/shared/utils/lexical/editor-image';

export interface WritableImageNode extends LexicalNode {
  setWidthAndHeight(
    width: 'inherit' | number,
    height: 'inherit' | number,
    constraints?: ImageDimensionConstraints,
  ): void;
}

export function $isWritableImageNode(
  node: LexicalNode | null | undefined,
): node is WritableImageNode {
  const candidate = node as Partial<WritableImageNode> | null | undefined;
  return node?.getType() === IMAGE_NODE_TYPE && typeof candidate?.setWidthAndHeight === 'function';
}
